import styled from 'styled-components';
import { device, hexToRGB } from '@/styles/helpers';

export const ScBadgePills = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    background: ${({ theme }) => hexToRGB(theme.blackColor, 0.4)};
    border-radius: 100px;
    padding: 8px 16px;
    font-family: "Work Sans", sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobile}) {
      padding: 8px 14px;
      font-size: 12px;
    }
  }
`;
